import { render, staticRenderFns } from "./order-by-status.vue?vue&type=template&id=f4c2b284&scoped=true&"
import script from "./order-by-status.vue?vue&type=script&lang=js&"
export * from "./order-by-status.vue?vue&type=script&lang=js&"
import style0 from "./order-by-status.vue?vue&type=style&index=0&id=f4c2b284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c2b284",
  null
  
)

export default component.exports